import React from 'react';
import { CimmplePayDocLayout } from './CimmplePayDocLayout';
import { coreFlowsMarkdown } from '../../../content/cimmplepay/core-flows.md';

const CoreFlows: React.FC = () => {
  return (
    <CimmplePayDocLayout
      seoTitle="Core Flows | CimmplePay Docs"
      seoDescription="Recommended CimmplePay integration patterns: employee sync, payroll lifecycle, payroll outputs, optional ERP journal sync, and retry/idempotency basics."
      markdown={coreFlowsMarkdown}
    />
  );
};

export default CoreFlows;
